import type { ReceiptTemplate } from '../schema';

export const bitcoinTemplate: ReceiptTemplate = {
  id: 'bitcoin',
  name: 'Bitcoin Receipt',
  brand: 'BITCOIN',
  description: 'Bitcoin transaction receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: 'none',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'btc-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'BITCOIN',
        businessNameFontSize: 18,
        addressLines: ['TRANSACTION RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'btc-trans',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'TX HASH:\n3a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6q\n\nBLOCK: 847291\nCONFIRMATIONS: 6', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'btc-amount',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'btc', label: 'BTC', value: '0.00125000', isBold: true, isLarge: true },
          { id: 'usd', label: 'USD VALUE', value: '125.00', isBold: false, isLarge: false },
          { id: 'fee', label: 'NETWORK FEE', value: '0.00001250', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'btc-details',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'DATE: 01/04/2026 2:45 PM\nSTATUS: CONFIRMED', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'btc-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'TRANSACTION COMPLETE', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: true },
    },
  ],
  updatedAt: new Date().toISOString(),
};

